import pythonApiClient from './pythonBaseApi';

export const parametriaApi = {
    // ESTADOS EMPLEADO
    getEstadosEmpleado: () => pythonApiClient.get('/rrhh/estados-empleado'),
    createEstadoEmpleado: (data) => pythonApiClient.post('/rrhh/estados-empleado', data),
    updateEstadoEmpleado: (id, data) => pythonApiClient.put(`/rrhh/estados-empleado/${id}`, data),
    deleteEstadoEmpleado: (id) => pythonApiClient.delete(`/rrhh/estados-empleado/${id}`),

    // SISTEMA PRIVADO PENSIONES (AFPs)
    getSistemasPensiones: () => pythonApiClient.get('/rrhh/sistema-privado-pensiones'),
    createSistemaPensiones: (data) => pythonApiClient.post('/rrhh/sistema-privado-pensiones', data),
    updateSistemaPensiones: (id, data) => pythonApiClient.put(`/rrhh/sistema-privado-pensiones/${id}`, data),
    deleteSistemaPensiones: (id) => pythonApiClient.delete(`/rrhh/sistema-privado-pensiones/${id}`),

    // PARAMETRIA PLANILLA
    getParametriasPlanilla: () => pythonApiClient.get('/rrhh/parametria'),
    getParametriaByCodigo: (codigo) => pythonApiClient.get(`/rrhh/parametria/${codigo}`),
    createParametriaPlanilla: (data) => pythonApiClient.post('/rrhh/parametria', data),
    updateParametriaPlanilla: (id, data) => pythonApiClient.put(`/rrhh/parametria/${id}`, data),
    deleteParametriaPlanilla: (id) => pythonApiClient.delete(`/rrhh/parametria/${id}`),
};
